import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import Dialog from 'material-ui/Dialog';

import { isDialogOpen } from '../../../actions/dialogs';

import styles from './styles';

class ReduxDialog extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    modal: PropTypes.bool,
    actions: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func,
    children: PropTypes.any.isRequired,
    titleStyle: PropTypes.object,
    subTitleStyle: PropTypes.object,
    bodyStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    overlayStyle: PropTypes.object,
    rightToolbar: PropTypes.object,
  };

  state = {};

  handleDiscard = () => {

  }

  handleSave = () => {

  }

  renderTitle() {
    const { title, subTitle, rightToolbar } = this.props;
    return (<div style={styles.titleContainer}>
      <div style={styles.titleSubTitleContainer}>
        <div>{title}</div>
        { subTitle ? <div style={_.assign({}, styles.subTitle, this.props.subTitleStyle)}>{subTitle}</div> : null }
      </div>
      { rightToolbar }
    </div>);
  }

  render() {
    const { modal, actions, open } = this.props;

    return (
      <Dialog
        title={this.renderTitle()}
        actions={actions}
        modal={modal || false}
        open={open === true}
        onRequestClose={this.handleDiscard}
        autoScrollBodyContent
        titleStyle={_.assign({}, styles.title, this.props.titleStyle)}
        bodyStyle={this.props.bodyStyle || styles.body}
        contentStyle={this.props.contentStyle || styles.content}
        overlayStyle={this.props.overlayStyle || styles.overlay}
      >
        {this.props.children}
      </Dialog>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

function mapStateToProps(state, props) {
  return {
    open: isDialogOpen(state.get('dialogs').get('dialogs').toJS(), props.name),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxDialog);



// WEBPACK FOOTER //
// ./src/components/Common/ReduxDialog/index.js